import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getBlog, getSavedBlog, getUpdatedBlog } from "./blogAPI";

const initialState = {
  blog: {},
  isLoading: false,
  isError: false,
  error: "",
};

export const fetchBlog = createAsyncThunk("blog/fetchBlog", async (id) => {
  const blog = await getBlog(id);
  return blog;
});

export const updateLike = createAsyncThunk(
  "blog/updateLike",
  async ({ id, likes }) => {
    const updatedBlog = await getUpdatedBlog(id, likes);
    return updatedBlog;
  }
);

export const savedBlog = createAsyncThunk(
  "blog/savedBlog",
  async ({ id, isSaved }) => {
    const savedBlog = await getSavedBlog(id, isSaved);
    return savedBlog;
  }
);

export const blogSlice = createSlice({
  name: "blog",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBlog.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
        state.error = "";
      })
      .addCase(fetchBlog.fulfilled, (state, action) => {
        state.isLoading = false;
        state.blog = action.payload;
      })
      .addCase(fetchBlog.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
        state.blog = {};
      });
  },
});

export default blogSlice.reducer;
